import UpdatePasswordModal from './update_password_modal'
export default UpdatePasswordModal
